<template>
  <div class="form-group mt-5">
    <div
      class="form-select form-control hasValue"
      :class="{ invalid: isInvalid() }"
    >
      <span class="w-100 text-truncate d-inline-block">{{
        getActiveTitle
      }}</span>
      <select
        :noTitle="true"
        :name="id"
        v-validate="config.Validation"
        ref="item"
        :value="value"
        @change="update()"
        autocomplete="off"
      >
        <option
          v-for="(item, i) in selectable"
          :key="i"
          :name="id"
          :value="item.Value"
        >
          {{ item.Title }}
        </option>
      </select>
    </div>
    <label
      class="form-control-placeholder"
      :for="'input' + id"
      v-if="isNoTitle()"
    >
      {{ config.Placeholder }}
      <span class="required-star" v-if="config.Placeholder">*</span>
    </label>
    <InfoText v-if="config.Info" :content="config.Info" :id="id" />
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ this.config.ErrorMessage }} skal udfyldes.
    </div>
    <div class="invalid-mandatory" v-if="illegal" v-html="errorText"></div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';

  export default {
    components: { InfoText },
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'options', 'config', 'id', 'noTitle'],
    data: function () {
      return {
        selectable: this.options,
        errorText: '',
        illegal: false,
      };
    },
    methods: {
      update() {
        var studentPage = this.$store.state.newData[2];
        var enrollmentDate = this.$store.state.enrollmentDate;
        if (enrollmentDate != '') {
          var date = new Date(this.$store.state.enrollmentDate);
          var year = enrollmentDate.split('-')[0];
          if (
            this.$refs.item.value == year &&
            studentPage.Questions[5].Value == 3
          ) {
            var spingDate = new Date(year + '-04-15');
            if (date >= spingDate) {
              this.setIllegal();
            } else {
              this.setSeleted();
            }
          } else if (
            this.$refs.item.value == year &&
            studentPage.Questions[5].Value == 4
          ) {
            var fallDate = new Date(year + '-10-15');
            if (date >= fallDate) {
              this.setIllegal();
            } else {
              this.setSeleted();
            }
          } else {
            this.setSeleted();
          }
        }
      },
      setIllegal() {
        var studentPage = this.$store.state.newData[2];
        this.illegal = true;
        this.errorText = studentPage.Questions[9].illegalPeriod;
        this.$emit('input', '');
        this.$emit('getNewData');
        this.$emit('setSelected');
      },
      setSeleted() {
        this.illegal = false;
        const valueAsNumber = Number(this.$refs.item.value);
        const value = isNaN(valueAsNumber)
          ? this.$refs.item.value
          : valueAsNumber;
        this.$emit('input', value);
        this.$emit('getNewData');
        this.$emit('setSelected');
      },
      selectOnlyOption() {
        this.$emit('input', this.options[1].Value);
        this.$emit('getNewData');
        this.$emit('setSelected');
        setTimeout(() => {
          this.$validator.validate();
        }, 0);
      },
      setDefault() {
        this.$emit('input', this.options[0].Value);
        this.$emit('getNewData');
        this.$emit('setSelected');
        setTimeout(() => {
          this.$validator.validate();
        }, 0);
      },
      isNoTitle() {
        if (this.noTitle == false) {
          return false;
        }
        return true;
      },
      isInvalid() {
        return (
          this.$store.state.componentIsInvalid &&
          this.value == '' &&
          this.config.Validation.required
        );
      },
    },
    watch: {
      options: function () {
        // watch it
        if (this.options.length == 2 && this.options[0].Value == 0) {
          // First on is "Vælg" placeholder
          this.selectOnlyOption();
        }
      },
    },
    computed: {
      getActiveTitle() {
        let activeEl = this.value;
        for (let index = 0; index < this.options.length; index++) {
          if (this.options[index].Value == this.value) {
            activeEl = this.options[index].Title;
          }
        }

        return activeEl;
      },
    },
    mounted() {
      this.update();
    },
  };
</script>
<style lang="scss" scoped>
  select option:first-child {
    display: none;
  }
</style>
